import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "535cbe90-34e1-416b-aca3-e0b478c72923", content: "3 ms", options: {} },
  { id: "77bc3c28-fbcb-4537-9e68-6626cfbbbfca", content: "30 ms", options: {} },
  { id: "092ce513-5c37-4f90-9b4c-fc3551e2c460", content: "0 ms (not earlier at all)", options: {} },
  { id: "d0762d60-c6e4-475f-9ed5-4397631a3981", content: "300 ms", options: {} },
];

export const task: Task = {
  id: "955f450c-0321-4b92-8595-b8618c750a01",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["77bc3c28-fbcb-4537-9e68-6626cfbbbfca"],
};
